//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class BoardStar extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'BoardStar';
  }
  getBoard() {
    return this.modelCache.get('Board', this.get('idBoard'));
  }
}
BoardStar.initClass();

export { BoardStar };
